import { cn } from '@/lib/utils';
import type { AuditSeverity } from '@claro/shared';
import { AUDIT_SEVERITY_LABELS } from '@claro/shared';

const SEVERITY_COLORS: Record<AuditSeverity, string> = {
  0: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30',
  1: 'bg-blue-500/15 text-blue-600 dark:text-blue-400 border-blue-500/30',
  2: 'bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30',
  3: 'bg-orange-500/15 text-orange-600 dark:text-orange-400 border-orange-500/30',
  4: 'bg-red-500/15 text-red-600 dark:text-red-400 border-red-500/30',
  5: 'bg-red-700/20 text-red-700 dark:text-red-300 border-red-700/40',
};

interface SeverityBadgeProps {
  severity: AuditSeverity;
  className?: string;
  showLabel?: boolean;
}

export function SeverityBadge({ severity, className, showLabel = true }: SeverityBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium',
        SEVERITY_COLORS[severity],
        className,
      )}
    >
      <span className="font-bold">{severity}</span>
      {showLabel && <span>· {AUDIT_SEVERITY_LABELS[severity]}</span>}
    </span>
  );
}
